import React from 'react'
import Moment from 'react-moment'
import { Button } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'

// Import icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

const LowInventoryUnit = ({ unit }) => {
  const location = useLocation()
  const tableRowClass =
    unit.qty === 0 ? 'inventory-out-stock'
    : unit.qty <= unit.lowinventory ? 'inventory-low-stock'
    : ''

  return (
    <tr className={tableRowClass}>
      <td>{unit.upc}</td>
      <td>{unit.item}</td>
      <td>{unit.manufacturer}</td>
      <td>{unit.subname}</td>
      <td>{unit.qty}</td>
      <td>{unit.lowinventory}</td>
      <td align='right'>
        {unit.price.toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD'
        })}
      </td>
      <td align='right'>
        <Moment format='M/D/YY, h:mm a'>{new Date(unit.updatedAt)}</Moment>
      </td>
      <td>
        <LinkContainer
          to={`/inventory/edit/${unit._id}`}
          state={{ from: `${location.pathname}${location.search}` }}
        >
          <Button variant='primary' size='sm'>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </LinkContainer>
      </td>
    </tr>
  )
}

export default LowInventoryUnit
